var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 3.07001C6.17866 3.07001 3.07001 6.17866 3.07001 10.0001C3.07001 13.8216 6.17866 16.9302 10.0001 16.9302C13.8216 16.9302 16.9302 13.8216 16.9302 10.0001C16.9302 6.17866 13.8216 3.07001 10.0001 3.07001ZM10.0001 17.5002C5.86455 17.5002 2.5 14.1357 2.5 10.0001C2.5 5.86455 5.86455 2.5 10.0001 2.5C14.1357 2.5 17.5002 5.86455 17.5002 10.0001C17.5002 14.1357 14.1357 17.5002 10.0001 17.5002Z",
    fill: "#20662E",
    stroke: "#20662E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09953 12.699C9.02273 12.699 8.94593 12.6696 8.88743 12.6111L6.48739 10.211C6.37009 10.0937 6.37009 9.90414 6.48739 9.78684C6.60469 9.66954 6.7943 9.66954 6.9116 9.78684L9.09953 11.9748L13.6875 7.3868C13.8048 7.2695 13.9944 7.2695 14.1117 7.3868C14.229 7.50411 14.229 7.69371 14.1117 7.81101L9.31163 12.6111C9.25313 12.6696 9.17633 12.699 9.09953 12.699Z",
    fill: "#20662E",
    stroke: "#20662E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenSuccess);
export default __webpack_public_path__ + "static/media/GreenSuccess.9b0e64d706b2d70390f91780ff9fb1c9.svg";
export { ForwardRef as ReactComponent };